import { Box } from '@urbaninfrastructure/react-ui-kit';

export default Box;
